import { render } from "./AssetManager.vue?vue&type=template&id=2a4b3cba"
import script from "./AssetManager.vue?vue&type=script&lang=js"
export * from "./AssetManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__